import * as React from 'react';
import { uiText } from '../helpers';

// Group switcher as a native <select>, matching the sidebar facet dropdowns for
// one consistent style. The base `nv-chart__facet-select` gives the shared look;
// the `nv-chart__group-select` modifier is a hook for any group-specific styling
// (spacing/width) the old bespoke group-selector carried.
export default function GroupDropdown({ groups = [], groupLabel, valueSetter }) {
  // A single group offers no choice, so the switcher is just noise — hide it and
  // let the one group render on its own.
  if (groups.length <= 1) {
    return null;
  }

  return (
    <select
      aria-label={uiText('select_group', 'Select benchmark group')}
      className="nv-chart__facet-select nv-chart__group-select"
      value={groupLabel ?? groups[0].label}
      onChange={(event) => valueSetter(event.target.value)}
    >
      {groups.map(group => (
        <option key={group.label} value={group.label}>{group.label}</option>
      ))}
    </select>
  );
}
